import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="flex h-24 w-24 items-center justify-center rounded-full bg-primary-100 text-5xl text-primary-600">
        <i className="ri-ghost-line"></i>
      </div>
      <h1 className="mt-6 font-heading text-7xl font-black text-foreground-200 md:text-9xl">404</h1>
      <p className="mt-3 text-xl font-semibold text-foreground-950">这个页面还没被画出来</p>
      <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-4 max-w-md text-base text-foreground-600">
        你找的漫画页面可能搬家了，或者它还在画师的草稿纸上……不如先回首页看看别的精彩作品？
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line"></i> 返回首页
      </Link>
    </div>
  );
}